import React from "react";
import { useForm } from "react-hook-form";

function Playground() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  console.log(errors);

  return (
    <div className="content">
      <h2>Playground</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          type="text"
          placeholder="Material Name"
          {...register("Material", {
            required: true,
            max: 50,
            min: 20,
            maxLength: 50,
          })}
        />
        <input
          type="number"
          placeholder="Price"
          step="0.01"
          {...register("Price", {
            required: true,
            max: 100,
            min: 0.01,

            pattern: {
              value: /^\d+(\.\d{1,2})?$/,
              message: " Maximum two decimal places allowed.",
            },
            prefix: "$",
          })}
        />
        <input
          type="text"
          placeholder="Description"
          {...register("Description", {
            required: true,
            max: 50,
            min: 20,
            maxLength: 50,
          })}
        />

        <input type="submit" />
      </form>
    </div>
  );
}

export default Playground;
